
		
				/** @jsx CsApp3.Core.createPureElement */
				/** @jsxFrag CsApp3.Core.createPureFragment */
			
		{
		
			let csapp_framework3 = CsApp3.get('csapp_framework3');
			
			
		csapp_framework3.component('fbox.Button', class extends CsApp3.Core.PureComponent {
			
			constructor(props){
			
				super(props);
				
				this.parent = props._parent_component;
				this.appFrame = props._cs_config.appFrame;
				
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
			
				return(
					<>
					{
					<button className={ this.utils.makeclass('btn btn-sm btn-outline-primary ms-1', this.props.btn.class ?? 'btn-outline-primary', 'btn-outline-primary') } >
				{' '}<i className={ this.utils.makeclass('me-1', this.props.btn.icon_class, '') } ></i>
				{' '}<span >{this.utils.ent_decode(this.props.btn.text)}</span>
			{' '}</button>
					}
					</>
				);
				
			} 
			
		});
		
		csapp_framework3.component('fbox.Renderer', class extends CsApp3.Core.PureComponent {
		
			constructor(props){
			
				super(props);
				
				this.appFrame = props._cs_config.appFrame;
			
				if(this.init){
					this.init();
				}
				
			}
			
			
			
			render(){
				return(
					<>
					<div  {...{'className': 'fbox-wrapper fbox-default-theme'}}  {...{'data-cs-app-ns': 'csapp_framework3'}} >
	{' '}<div  {...{'className': 'fbox-overlay'}} ></div>
	{' '}<div  {...{'className': 'fbox'}} >
		{' '}<div  {...{'className': 'fbox-title'}} >
			{' '}<div  {...{'className': 'title-text'}} >{this.utils.ent_decode(this.props.title)}</div>
			{' '}<div  {...{'className': 'close-btn'}} ><i  {...{'className': 'fas fa-times'}} ></i></div> 
		{' '}</div>
		{' '}<div  {...{'className': 'fbox-content message'}} >{}</div>
		{' '}<div  {...{'className': 'fbox-buttons'}} >{ 
						Object.entries(this.props.buttons).map((btn) => {   
							return (<> { <csapp_framework3.components.fbox.Button btn={ btn[1] } _cs_config={ this.props._cs_config } _parent_component={ this } /> } </>);
						})
					}</div> 
	{' '}</div>
{' '}</div>
					</>
				);
			} 
			
		});
		
			
		}